var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c("div", { staticClass: "mobile-contract-header" }, [
      _c("div", {
        staticClass: "small fw-bold",
        domProps: { innerHTML: _vm._s(_vm.contractName(_vm.contract)) },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-contract-wrapper" },
      [
        _c(
          "div",
          {
            staticClass: "mobile-contract-card-image d-flex align-items-center",
          },
          [
            _vm.contract.imageDevice
              ? _c("img", {
                  class: [
                    "h-100",
                    !_vm.contract.descriptionDevice ? "w-75" : "w-100",
                  ],
                  attrs: {
                    src: _vm.contract.imageDevice.src,
                    alt: _vm.contract.imageDevice.alt,
                  },
                })
              : _c("span", {
                  staticClass: "icon icon-device-smart-phone",
                  attrs: { "aria-hidden": "true" },
                }),
          ]
        ),
        _vm._v(" "),
        _c(
          "ob1-cards",
          {
            staticClass: "pt-1 px-1 mb-1 mobile-contract-card bg-white",
            attrs: { "is-multiple": true, "with-composite-link": false },
          },
          [
            _c("div", { staticClass: "mobile-contract-card-item" }, [
              _vm.contract.withDroMessage
                ? _c(
                    "div",
                    { staticClass: "alert-wrapper" },
                    [
                      _c("zone-contracts-alert", {
                        attrs: {
                          message: _vm.contract.labels.droMessage,
                          "link-url": _vm.contract.changeDeviceLinkUrl,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "title-big fw-bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.contract.labels.changeDeviceLabel) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "items-list row mb-0" }, [
                _c("li", { staticClass: "col-12" }, [
                  _c(
                    "a",
                    {
                      staticClass: "items-list-item",
                      attrs: {
                        href: _vm.contract.changeDeviceLinkUrl,
                        "data-oevent-category":
                          _vm.contract.tmsChangeDevice.tagZone +
                          (_vm.index + 1),
                        "data-oevent-action":
                          _vm.contract.tmsChangeDevice.tagName,
                        "data-oevent-label": _vm.contract.changeDeviceLinkUrl,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "item-container no-border-bottom" },
                        [
                          _c("div", { staticClass: "item-text" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.contract.descriptionDevice)),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "item-desc" }, [
                              _vm._v(
                                _vm._s(_vm.contract.labels.changeDeviceText)
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ob1-cards",
          {
            staticClass: "pt-1 px-1 mb-1",
            attrs: { "is-multiple": true, "with-composite-link": false },
          },
          [
            _c("div", { staticClass: "mobile-contract-card-item" }, [
              _c("div", { staticClass: "title-big fw-bold" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.contract.labels.changeOfferLabel) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "items-list row mb-0" }, [
                _c("li", { staticClass: "col-12" }, [
                  _c(
                    "a",
                    {
                      staticClass: "items-list-item",
                      attrs: {
                        href: _vm.contract.changeOfferLinkUrl,
                        "data-oevent-category":
                          _vm.contract.tmsChangeOffer.tagZone + (_vm.index + 1),
                        "data-oevent-action":
                          _vm.contract.tmsChangeOffer.tagName,
                        "data-oevent-label": _vm.contract.changeOfferLinkUrl,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "item-container no-border-bottom" },
                        [
                          _c("div", { staticClass: "item-text" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.contract.mainOfferLabel)),
                            ]),
                            _vm._v(" "),
                            _c("small", { staticClass: "item-desc" }, [
                              _vm._v(
                                _vm._s(_vm.contract.labels.changeOfferText)
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ob1-cards",
          {
            staticClass: "pt-1 px-1",
            attrs: { "is-multiple": true, "with-composite-link": false },
          },
          [
            _c(
              "div",
              { staticClass: "mobile-contract-card-item" },
              [
                _c("div", { staticClass: "standard text-gray3 fw-bold" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.contract.labels.manageOfferLabel) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("ob1-liens", {
                  staticClass: "pb-0",
                  attrs: {
                    text: _vm.contract.labels.manageOfferLink1,
                    href: _vm.contract.manageOfferLink1Url,
                    "with-arrow": "",
                    "data-oevent-category":
                      _vm.contract.tmsManageOffer1.tagZone + (_vm.index + 1),
                    "data-oevent-action": _vm.contract.tmsManageOffer1.tagName,
                    "data-oevent-label": _vm.contract.manageOfferLink1Url,
                  },
                }),
                _vm._v(" "),
                _c("ob1-liens", {
                  attrs: {
                    text: _vm.contract.labels.manageOfferLink2,
                    href: _vm.contract.manageOfferLink2Url,
                    "with-arrow": "",
                    "data-oevent-category":
                      _vm.contract.tmsManageOffer2.tagZone + (_vm.index + 1),
                    "data-oevent-action": _vm.contract.tmsManageOffer2.tagName,
                    "data-oevent-label": _vm.contract.manageOfferLink2Url,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }